<template>
  <div v-loading="loading" class="[ mk-orderlist ]" style="min-height: 300px">
    <div v-if="orders.length > 0">
      <div v-for="order in orders" v-bind:key="order.id" class="got-order-row container mb-2 px-0"
        style="overflow: hidden">
        <div class="row p-3" :class="order.show ? 'light-grey-bg' : ''">
          <div class="col-9">
            <div class="row">
              <div class="col-lg-2 col-sm-6">
                <p class="mb-0 text-black-500 font-14">
                  <strong>ORDER:</strong>
                </p>
                <p class="mb-0 font-16">{{ order.id }}</p>
              </div>

              <!-- Order type -->
              <div class="col-lg-3 col-sm-6">
                <p class="mb-0 text-black-500 font-14">
                  <strong>{{ order.order_type_id == 3 ? "PICKUP" : "DELIVERY" }}
                    DATE:
                  </strong>
                </p>
                <p class="mb-0 font-16">
                  {{ order.delivery_date ? moment(order.delivery_date).format("DD MMM YYYY") : 'N/A' }}
                </p>
              </div>

              <!-- Total -->
              <div class="col-lg-4 col-sm-6">
                <p class="mb-0 text-black-500 font-14">
                  <strong>VARIETY:</strong>
                </p>
                <div class="font-16">
                  <p class="mb-1">{{ order.items.length > 0 ? order.items[0].grass.full_name : '' }}</p>
                  <p class="mb-0">{{ order.items.length > 1 ? `+${order.items.length - 1} others` : '' }}</p>
                </div>
              </div>

              <!-- Status -->
              <div class="col-lg-3 col-sm-6">
                <p class="mb-0 text-black-500 font-14">
                  <strong>STATUS:</strong>
                </p>
                <p class="mb-0 font-16">{{ order.customer_status }}</p>
              </div>
            </div>
          </div>

          <div class="col-3 text-right d-flex align-items-center">
            <a class="ml-auto text-green-primary" href="" @click="showOrder($event, order)">
              <strong>{{ order.show ? "Hide" : "Show" }} Details</strong>
              <i class="fas pl-1 text-green-primary" :class="order.show ? 'fa-chevron-up' : 'fa-chevron-down'"></i></a>
          </div>
        </div>

        <div class="container" v-if="order.show">
          <div class="row">
            <div class="mt-3 col-12 d-flex align-items-start justify-content-between">
              <h2 class="mb-0 font-18">
                {{ order.order_type_id == 3 ? "Pickup" : "Delivery" }} details
              </h2>

              <div>
                <a v-if="
                  edit_order(order) &&
                  [3, 10, 11, 12].includes(order.order_status_id)
                " class="btn-primary-rounded" :href="`/orders/${order.id}/edit`">
                  <i class="fas fa-pencil pr-2"></i>Edit order
                </a>

                <div v-else class="d-flex align-items-center">
                  <!-- <a :href="`/orders/${order.id}/invoice`" class="mr-2 btn-primary-outline"
                    v-if="order.payment_status_id == 6" target="_blank" style="max-width: 200px">
                    <i class="far fa-download mr-2"></i> Download Invoice</a> -->
                  <a class="btn-primary-outline" :href="`/orders/${order.id}`"><i class="fal fa-eye mr-2"></i> View
                    Order</a>
                </div>
              </div>
            </div>

            <!-- Delivery address -->
            <div class="col-6 col-lg-4" v-if="[1, 2].includes(order.order_type_id)">
              <p class="mb-1 font-14 text-black-500 text-uppercase">
                <strong>DELIVERY ADDRESS</strong>
              </p>
              <div>
                {{ order.site_contact_name }}<br />
                {{ order.address_with_unit_number }}
              </div>
            </div>

            <!-- Phone Number -->
            <div class="col-6 col-lg-4" v-if="[1, 2].includes(order.order_type_id)">
              <p class="mb-1 font-14 text-black-500 text-uppercase">
                <strong>PHONE NUMBER</strong>
              </p>
              <div>{{ order.site_contact_phone }}</div>
            </div>

            <!-- Pickup details -->
            <div class="col-6 col-lg-4" v-if="[3].includes(order.order_type_id)">
              <p class="mb-1 font-14 text-black-500 text-uppercase">
                <strong> Pickup time</strong>
              </p>
              <div>
                {{
                    order.pick_up_at
                      ? moment(order.pick_up_at, "HH:mm:ss").format("hh:mm A")
                      : ""
                }}
              </div>
            </div>

            <!-- Order details -->
            <div class="col-10">
              <h2 class="my-4 font-18">Your Order</h2>

              <div class="row align-items-center" v-for="item in order.items" v-bind:key="item.id">
                <div class="col-2">
                  <img v-if="item.grass.thumbnail" :src="item.grass.thumbnail.url" width="100%" class="img-fluid"
                    style="max-width: 73px" />
                </div>
                <div class="col-6">
                  <p class="mb-0">
                    <strong>{{ item.grass.full_name }}</strong>
                  </p>
                </div>
                <div class="col-2">
                  <p class="mb-0">{{ item.size_sqm }} m2</p>
                </div>
                <div class="col-2 text-right">
                  <p class="mb-0">
                    {{
                        new Intl.NumberFormat("en-AU", {
                          style: "currency",
                          currency: "AUD",
                        }).format(Number(item.size_sqm_turf_dollar_price))
                    }}
                  </p>
                </div>

                <div class="col-12">
                  <hr class="" />
                </div>
              </div>

              <div class="row justify-content-md-end">
                <div class="col-2">
                  <p class="mb-0 font-14">Subtotal</p>
                </div>
                <div class="col-2 text-right">
                  <p class="mb-0 font-14">
                    {{
                        new Intl.NumberFormat("en-AU", {
                          style: "currency",
                          currency: "AUD",
                        }).format(Number(order.price / this.$PRICE_CONVERSION_FACTOR))
                    }}
                  </p>
                </div>
              </div>

              <div class="row justify-content-md-end" v-if="order.order_type_id == 2">
                <div class="col-2">
                  <p class="mb-0 font-14">Laying</p>
                </div>
                <div class="col-2 text-right">
                  <p class="mb-0 font-14">
                    {{
                        new Intl.NumberFormat("en-AU", {
                          style: "currency",
                          currency: "AUD",
                        }).format(Number(order.laying_dollar_price))
                    }}
                  </p>
                </div>
              </div>

              <div class="row justify-content-md-end" v-if="[1, 2].includes(order.order_type_id)">
                <div class="col-2">
                  <p class="mb-0 font-14">Delivery</p>
                </div>
                <div class="col-2 text-right">
                  <p class="mb-0 font-14">
                    {{
                        new Intl.NumberFormat("en-AU", {
                          style: "currency",
                          currency: "AUD",
                        }).format(Number(order.freight_dollar_price))
                    }}
                  </p>
                </div>
              </div>

              <div class="row justify-content-md-end">
                <div class="col-2" style="
                    padding-bottom: 6px;
                    margin-bottom: 6px;
                    border-bottom: 1px solid var(--got-bg-grey);
                  ">
                  <p class="mb-0 font-14">GST</p>
                </div>
                <div class="col-2 text-right" style="
                    padding-bottom: 6px;
                    margin-bottom: 6px;
                    border-bottom: 1px solid var(--got-bg-grey);
                  ">
                  <p class="mb-0 font-14">
                    {{
                        new Intl.NumberFormat("en-AU", {
                          style: "currency",
                          currency: "AUD",
                        }).format(Number(gstOrder(order)))
                    }}
                  </p>
                </div>
              </div>

              <div class="row justify-content-md-end" style="margin-bottom: 32px">
                <div class="col-2">
                  <p class="mb-0 font-18"><strong>Total</strong></p>
                </div>
                <div class="col-2 text-right">
                  <p class="mb-0 font-18">
                    <strong>
                      {{
                          new Intl.NumberFormat("en-AU", {
                            style: "currency",
                            currency: "AUD",
                          }).format(Number(totalOrder(order)))
                      }}</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <el-pagination background :pager-count="5" layout="prev, pager, next, jumper" @current-change="getOrders"
        :current-page.sync="page" :page-size="per_page" :total="total">
      </el-pagination>
    </div>

    <div v-else>No orders {{ tab }}</div>
  </div>
</template>

<script>
import Order from "../../../models/customer/Order";
export default {
  props: {
    tab: {
      type: String,
    },
    query: {
      type: String,
    },
  },
  data() {
    return {
      orders: [],
      loading: false,
      per_page: 7,
      page: 1,
    };
  },
  mounted() {
    this.getOrders();
  },
  watch: {
    query: function (newVal, oldVal) {
      // watch it
      this.getOrders();
    },
  },
  methods: {
    getOrders(page = 1) {
      this.loading = true;
      let orders = Order.page(page)
        .include("items.grass")
        .append("price,customer_status");

      orders.orderBy("-created_at");

      if (this.tab == "placed") {
        orders.whereIn("order_status_id", [2, 3, 8, 10, 11, 12, 13]);
      }
      if (this.tab == "confirmed") {
        orders.whereIn("order_status_id", [10, 11, 12]);
        orders.where("confirmation_sent", true);
      }
      if (this.tab == "delivered") {
        orders.whereIn("order_status_id", [8, 13]);
      }

      if (this.query) {
        orders.where("where_like", this.query);
      }

      orders.params({ per_page: this.per_page });

      orders
        .get()
        .then((res) => {
          this.orders = res.data;
          this.page = res.current_page;
          this.total = res.total;
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    showOrder(e, order) {
      e.preventDefault();
      this.$set(order, "show", !order.show);
    },
    gstOrder(order) {
      if (order.items.length || order.care_items.length) {
        return (
          Number(
            this.reduceArray(order.items, "size_sqm_turf_dollar_price") +
            order.freight_dollar_price +
            order.laying_dollar_price
          ) / 10
        ).toFixed(2);
      }

      return 0;
    },
    totalOrder(order) {
      return (
        Number(order.freight_dollar_price) +
        Number(order.laying_dollar_price) +
        Number(order.price / this.$PRICE_CONVERSION_FACTOR) +
        Number(this.gstOrder(order))
      );
    },
    limit_edit_date(order) {
      return order.delivery_date ? moment(order.delivery_date)
        .set({
          hour: 7,
          minute: 0,
          second: 0,
        })
        .subtract(1, "day")
        .format("YYYY-MM-DD hh:mm a") : 'N/A';
    },
    edit_order(order) {
      return moment(moment(this.limit_edit_date(order))).diff(moment()) >= 0;
    },
    reduceArray(object, key) {
      if (object) {
        return object.reduce(function (accumulator, currentValue) {
          return accumulator + parseFloat(currentValue[key]);
        }, 0);
      } else {
        return 0;
      }
    },
  },
};
</script>
